<template>
<div class="infocard">
    <p class="table-header small-text">
        <span class="mname-header">Наявні препарати</span> <span>Залишок препарату, доз</span>
    </p>

    <div v-for="(m, index) in af.last_r.medicines" :key="index" :class="`medicine-card ${m.open ? 'open' : 'closed'}`">
        <a class="mname-row" @click="clicked(m, index)">
            <span class="mname">{{m.name}} <span class="dosage small-text">{{m.dosage}}</span></span><span class="chevron"></span><span class="unitBalanseEnd">{{ format(sum(m, 'unitBalanseEnd')) }}</span>
        </a>
        <div class="details small-text">
            <p><span class="caption">Форма випуску:</span> <span class="value">{{ m.releaseForm }}</span></p>
            <p><span class="caption">Дозування:</span> <span class="value">{{ m.dosage }}</span></p>
            <p><span class="caption">Наявний у лікарнях:</span> 
                <span class="value" v-for="(fname, index) in get_facilities(m.rows)" :key="index"> 
                    {{ fname }} 
                    <span v-if="index < get_facilities(m.rows).length-1">, </span>
                </span>
            </p>
            <p class="chart_container"><span class="caption">Графік наявності препарату (місяці):</span> <bar-chart :dataset="chart_data[m.medicine]" /> </p>
            
            <orders-table :orders="orders_map.get(r.region).get(m.medicine)" />

        </div>
    </div>
    
    <p class="subheader courses-header">Орієнтовна кількість курсів лікування: 
        <tooltip> 
            <div>
                <p>Орієнтовна кількість курсів розраховується на основі референтних значень кількості доз, потрібних для лікування:</p>
                <br>
                <p>Ентекавір, Ламівудин, Тенофовір – 365 доз\курс</p>
                <p>Пегінтерферон – 48 доз\курс</p>
                <p>Інші препарати – 84 дози\курс</p>
            </div>
        </tooltip>
    </p>
    <courses-table :f="af" :config="config"/>
</div>
    
</template>

<script>
import * as d3_array from 'd3-array';

import BarChart from './BarChart';
import CoursesTable from './CoursesTable.vue';
import OrdersTable from './OrdersTable.vue';
import Tooltip from './Tooltip';

import { last } from '../utils.js';

function aggr_meds(meds) {
    return {
        unitBalanseEnd: d3_array.sum(meds, 
            m => d3_array.sum(m.rows, r => +r.unitBalanseEnd || 0)
        )
    }
}

export default {
    props: ['config', 'r', 'orders_map'],

    components: {
        BarChart,
        CoursesTable,
        OrdersTable,
        Tooltip,
    },
    
    data() {
        return {
            region: null,
        }
    },

    computed: {

        af() {
            console.log(this.r.aggregated_facility)
            return this.r.aggregated_facility;
        },

        last_r(){
            return this.r.aggregated_facility.last_r;
        },

        medicine_date_index() {
            return d3_array.rollup(this.af.reports, 
                v => d3_array.rollup([].concat(...v.map(r => r.medicines)), vv => aggr_meds(vv), m => m.medicine), 
                r => r.month
            )
        },

        dates() {
            return this.config.dates.map(d => d.substring(0, 7))
        },

        chart_data() {
            // let reports = this.af.reports;
            let medicines = this.last_r.medicines.map(m => m.medicine);

            let res = {};

            medicines.forEach(m => {
                res[m] = [];
                
                this.dates.forEach(d => {
                    let medicines_for_d = this.medicine_date_index.get(d);

                    let value = 0;
                    if (medicines_for_d) {
                        let med = medicines_for_d.get(m);
                        
                        if (med) {
                            value = med.unitBalanseEnd || 0;
                        }
                    }

                    res[m].push({
                        month: d,
                        value: value,
                    })
                })
            });
            return res;
        }
    },

    methods: {
        agg(m, fieldname) {
            //aggregate
            let rows = m.rows;
            let values = rows.map(r => r[fieldname] || '[не вказано]');
            return Array.from(d3_array.union(values)).join(", ")
        },

        sum(m, fieldname) {
            let rows = m.rows;
            let values = rows.map(r => +r[fieldname] || 0);
            return values.reduce((o, v, i) => o + v);
        },

        format: function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },

     
        clicked(m, index){
            this.last_r.medicines.forEach((m, idx) => {
                if (idx!==index) m.open = false
            })
            m.open = !m.open;
        },

        get_facilities(rows) {
            return [...new Set(rows.map(r => r.facility_name))]
        }

    }
}
</script>     

<style lang="scss" scoped>


.table-header {
    color: var(--col-main-grey);

    .mname-header {
        display: inline-block;
        min-width: 32em;

    }
}

.medicine-card {
    color: var(--col-mainblue);
    border-bottom: 1px solid black;
    
    .mname-row {
        cursor: pointer;
        display: block;
        padding: 0.5em 0;
        
        &:hover {
            background-color: var(--col-grey);
        }
    }


    .mname {
        display: inline-block;
        text-transform: uppercase;
        letter-spacing: -0.05em;
        min-width: 25em;

        .dosage {
            color: var(--col-main-grey);
        }
    }

    .unitBalanseEnd {
        display: inline-block;
        margin-left: 1em;
        font-size: 0.8em;
        min-width: 10em;
        text-align: right;
    }

    .details {
        p {
            margin-bottom: 0.3rem;
        }

        .caption {
            color: var(--col-main-grey);
        }
    }

    .details {
        height: 0;
        overflow: hidden;
        transition: height ease-in-out 0.2s;
    }

    $chevron_size: 8px;

    .chevron {
        display: inline-block;
        margin-left: 1em;

        width: 0; 
        height: 0; 
        border-top: $chevron_size solid transparent;
        border-bottom: $chevron_size solid transparent;
        border-left: $chevron_size solid var(--col-orange);

        transition: transform 0.2s
    }

    &.open {
        .details {
            height: auto;
        }
        .chevron {
            transform: rotate(90deg)
        }
    }

    .chart_container {
        margin-top: 1em;
    }

}

.courses-header {
    margin-top: 2em;;
}

.contact-info, .last-report {
    margin-top: 1rem;
    color: var(--col-main-grey);
}

.orders-table {
    margin-top: 2em;
    margin-bottom: 2em;
}

</style>
